import store from './store'

$(() => {
  const location = window.location.href
  if (location.split('communities/').length >= 2 && location.split('communities/')[1] !== '') {
    const wpUrl = 'https://paredimcommunities.com/specials'
    const propId = $('[data-prop]')[0].attributes['data-prop'].value

    $.ajax({
      url: wpUrl + '/wp-json/wp/v2/community?per_page=100',
      method: 'GET'
    })
      .then((res) => {
        // Get the individual property
        const thisProp = res.filter((e) => {
          return e.acf.propid === propId
        })
        return thisProp
      })
      .then((res) => {
        // Update specials bar, if any.
        const singleElement = res[0]
        if (res.length !== 0 && res[0].acf.special.replace('<p>', '').replace('</p>', '') !== '') {
          $('.updated-offer').html(res[0].acf.special.replace('<p>', '').replace('</p>', ''))
          $('#isSpecial').slideDown()
        }

        return singleElement
      })
      .then((res) => {
        if (res.acf.employers) {
          $('.is-pref-employer').css('display', 'block')
          $('.pref-employer-link').css('opacity', '1').css('pointer-events', 'auto')
        }
        // Create preferred employer page
        const community = res.acf
        const discounts = res.acf.discounts
        const participants = res.acf.hero_program
        const employers = res.acf.employers
        const programCopy = res.acf.program_copy
        const image = res.acf['pref-employer-image']

        // console.log(community, image)

        if (!discounts) { }
        else {
          discounts.forEach((e, i) => {
            $('ul[data-update="discounts"]').append(`<li class="features__list-item">${e.discount}</li>`)
          })
        }

        if (!employers) { }
        else {
          employers.sort(function (a, b) {
            var nameA = a.employer_name.toLowerCase(), nameB = b.employer_name.toLowerCase();
            if (nameA < nameB)
              return -1;
            if (nameA > nameB)
              return 1;
            return 0;
          });

          employers.forEach((e, i) => {
            $('[data-update="employer"]').append(`<li class="employer-program-item" data-id="${i}"><a href="${e.employer_website}" target="_blank">${e.employer_name}</a></li>`)
          })
        }

        if (!participants) { }
        else {
          participants.forEach((e, i) => {
            $('ul[data-update="participants"]').append(`<li class="features__list-item">${e.participants}</li>`)
          })
        }

        if (!programCopy) { }
        else {
          $('p[data-update="program_copy"]').text(programCopy)
        }

        if (!image) { }
        else {
          $('div[data-update="pref-employer-img"]').css('background-image', `url(${image})`)
        }
      })
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/communityApiCall.js